import React from 'react';

/** Decorative dot pattern behind the "your farms" summary on the legacy farms page. */
export const FarmDotsBackground = () => {
  return (
    <div className="absolute left-0 bottom-0">
      <svg
        width="292"
        height="55"
        viewBox="0 0 292 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <circle
            opacity="0.35"
            cx="141.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 141.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="148.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 148.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="8.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 8.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="155.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 155.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="15.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 15.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="162.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 162.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="22.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 22.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="169.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 169.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="29.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 29.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="176.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 176.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="36.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 36.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="183.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 183.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="43.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 43.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="190.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 190.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="50.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 50.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="197.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 197.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="57.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 57.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="204.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 204.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="64.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 64.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="211.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 211.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="71.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 71.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="218.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 218.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="78.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 78.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="225.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 225.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="85.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 85.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="232.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 232.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="92.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 92.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="239.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 239.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="99.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 99.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="246.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 246.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="106.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 106.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="253.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 253.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="113.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 113.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="260.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 260.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="120.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 120.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="267.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 267.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="127.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 127.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="274.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 274.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="134.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 134.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="281.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 281.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.35"
            cx="288.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 288.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="141.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 141.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="1.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 1.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="1.5"
            cy="50.5"
            r="1.5"
            transform="rotate(-180 1.5 50.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="148.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 148.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="8.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 8.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="155.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 155.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="15.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 15.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="162.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 162.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="22.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 22.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="169.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 169.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="29.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 29.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="176.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 176.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="36.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 36.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="183.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 183.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="43.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 43.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="190.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 190.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="50.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 50.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="197.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 197.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="57.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 57.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="204.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 204.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="64.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 64.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="211.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 211.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="71.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 71.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="218.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 218.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="78.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 78.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="225.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 225.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="85.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 85.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="232.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 232.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="92.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 92.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="239.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 239.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="99.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 99.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="246.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 246.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="106.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 106.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="253.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 253.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="113.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 113.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="260.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 260.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="120.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 120.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="267.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 267.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="127.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 127.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="274.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 274.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="134.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 134.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="281.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 281.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.3"
            cx="288.5"
            cy="42.5"
            r="1.5"
            transform="rotate(-180 288.5 42.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="141.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 141.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="1.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 1.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="148.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 148.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="8.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 8.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="155.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 155.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="15.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 15.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="162.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 162.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="22.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 22.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="169.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 169.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="29.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 29.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="176.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 176.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="36.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 36.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="183.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 183.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="43.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 43.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="190.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 190.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="50.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 50.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="197.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 197.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="57.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 57.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="204.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 204.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="64.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 64.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="211.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 211.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="71.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 71.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="218.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 218.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="78.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 78.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="225.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 225.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="85.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 85.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="232.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 232.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="92.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 92.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="239.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 239.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="99.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 99.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="246.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 246.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="106.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 106.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="253.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 253.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="113.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 113.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="260.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 260.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="120.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 120.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="267.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 267.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="127.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 127.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="274.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 274.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="134.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 134.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="281.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 281.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.25"
            cx="288.5"
            cy="34.5"
            r="1.5"
            transform="rotate(-180 288.5 34.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="141.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 141.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="1.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 1.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="148.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 148.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="8.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 8.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="155.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 155.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="15.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 15.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="162.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 162.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="22.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 22.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="169.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 169.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="29.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 29.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="176.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 176.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="36.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 36.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="183.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 183.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="43.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 43.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="190.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 190.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="50.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 50.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="197.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 197.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="57.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 57.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="204.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 204.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="64.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 64.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="211.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 211.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="71.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 71.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="218.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 218.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="78.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 78.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="225.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 225.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="85.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 85.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="232.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 232.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="92.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 92.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="239.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 239.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="99.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 99.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="246.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 246.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="106.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 106.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="253.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 253.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="113.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 113.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="260.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 260.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="120.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 120.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="267.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 267.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="127.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 127.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="274.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 274.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="134.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 134.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="281.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 281.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.2"
            cx="288.5"
            cy="26.5"
            r="1.5"
            transform="rotate(-180 288.5 26.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="141.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 141.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="1.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 1.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="148.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 148.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="8.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 8.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="155.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 155.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="15.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 15.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="162.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 162.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="22.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 22.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="169.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 169.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="29.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 29.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="176.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 176.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="36.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 36.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="183.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 183.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="43.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 43.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="190.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 190.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="50.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 50.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="197.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 197.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="57.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 57.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="204.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 204.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="64.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 64.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="211.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 211.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="71.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 71.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="218.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 218.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="78.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 78.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="225.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 225.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="85.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 85.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="232.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 232.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="92.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 92.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="239.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 239.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="99.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 99.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="246.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 246.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="106.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 106.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="253.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 253.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="113.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 113.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="260.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 260.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="120.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 120.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="267.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 267.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="127.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 127.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="274.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 274.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="134.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 134.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="281.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 281.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.15"
            cx="288.5"
            cy="18.5"
            r="1.5"
            transform="rotate(-180 288.5 18.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="141.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 141.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="1.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 1.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="148.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 148.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="8.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 8.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="155.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 155.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="15.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 15.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="162.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 162.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="22.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 22.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="169.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 169.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="29.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 29.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="176.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 176.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="36.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 36.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="183.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 183.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="43.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 43.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="190.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 190.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="50.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 50.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="197.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 197.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="57.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 57.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="204.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 204.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="64.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 64.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="211.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 211.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="71.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 71.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="218.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 218.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="78.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 78.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="225.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 225.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="85.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 85.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="232.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 232.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="92.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 92.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="239.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 239.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="99.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 99.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="246.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 246.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="106.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 106.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="253.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 253.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="113.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 113.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="260.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 260.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="120.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 120.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="267.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 267.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="127.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 127.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="274.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 274.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="134.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 134.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="281.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 281.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.1"
            cx="288.5"
            cy="10.5"
            r="1.5"
            transform="rotate(-180 288.5 10.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="141.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 141.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="1.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 1.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="148.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 148.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="8.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 8.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="155.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 155.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="15.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 15.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="162.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 162.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="22.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 22.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="169.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 169.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="29.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 29.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="176.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 176.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="36.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 36.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="183.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 183.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="43.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 43.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="190.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 190.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="50.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 50.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="197.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 197.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="57.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 57.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="204.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 204.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="64.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 64.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="211.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 211.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="71.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 71.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="218.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 218.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="78.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 78.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="225.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 225.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="85.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 85.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="232.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 232.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="92.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 92.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="239.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 239.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="99.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 99.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="246.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 246.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="106.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 106.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="253.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 253.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="113.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 113.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="260.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 260.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="120.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 120.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="267.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 267.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="127.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 127.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="274.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 274.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="134.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 134.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="281.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 281.5 2.5)"
            fill="white"
          />
          <circle
            opacity="0.05"
            cx="288.5"
            cy="2.5"
            r="1.5"
            transform="rotate(-180 288.5 2.5)"
            fill="white"
          />
          <path
            d="M70 5C70 2.23857 72.2386 0 75 0H287C289.761 0 292 2.23858 292 5V50C292 52.7614 289.761 55 287 55H78C73.5817 55 70 51.4183 70 47V5Z"
            fill="url(#paint0_linear_7843_655)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_7843_655"
            x1="224.494"
            y1="-1.48561e-06"
            x2="147.923"
            y2="76.109"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1D2932" />
            <stop offset="1" stopColor="#1D2932" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
